import { render, staticRenderFns } from "./OrdersAddendums.vue?vue&type=template&id=3cd586a4&"
import script from "./OrdersAddendums.vue?vue&type=script&lang=js&"
export * from "./OrdersAddendums.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports